import type { Meetversies } from './work-quality.api';

/** Vanaf deze meetversie rekent de dienst per werksoort; een week daarvoor heeft dat rapport niet (SPEC-mijn-feedback-weekrapport). */
export const EERSTE_MEETVERSIE_MET_WEEKRAPPORT = 10;

/**
 * AD-24 — één meting per beeld, herkenbaar aan twee versienummers.
 *
 * `meetVersie` zegt welke formule de getallen maakte, `instellingVersie` welke drempel bepaalde
 * wát er te zien is. Een beeld dat zijn onderdelen in meerdere aanroepen ophaalt kan er twee
 * lezingen tussen krijgen — een beheerder die de drempel middenin verzet is genoeg. Dan is het
 * antwoord niet "toon het gemiddelde van de twee" maar "haal het opnieuw op".
 */
export function versieSleutel(afbakening: Meetversies | undefined): string {
  return `${afbakening?.meetVersie}/${afbakening?.instellingVersie}`;
}

/** True zodra twee onderdelen niet uit dezelfde meting komen. Nul of één onderdeel kan dat niet. */
export function metingenLopenUiteen(afbakeningen: readonly Meetversies[]): boolean {
  if (afbakeningen.length < 2) return false;
  const eerste = versieSleutel(afbakeningen[0]!);
  return afbakeningen.some((afbakening) => versieSleutel(afbakening) !== eerste);
}

/**
 * True voor een week die vóór meetversie 10 is gemeten. Die week heeft geen weekrapport per werksoort,
 * en de oude weergave toont namen van nakijkers, dus het eigen weekscherm toont er alleen een melding voor
 * (beslissing 22, 20-10-2026).
 */
export function isVoorWeekrapport(afbakening: Meetversies): boolean {
  // Een onbekende versie (null of ontbrekend) blijft zoals hij was: null < 10 is in JavaScript true.
  return typeof afbakening.meetVersie === 'number' && afbakening.meetVersie < EERSTE_MEETVERSIE_MET_WEEKRAPPORT;
}
